import React from 'react';

import type { ClaimNotificationModel } from '~/components/ClaimNotificationsCard/types';
import Tooltip from '~/components/core/Atomic/Tooltip';
import Typography from '~/components/core/Atomic/Typography';
import LockedIcon from '~/components/icons/LockedIcon';

interface NotificationAssigneeProps {
  notification: ClaimNotificationModel;
}

const NotificationAssignee: React.FC<NotificationAssigneeProps> = ({ notification }) => {
  return (
    <div>
      <Typography display="block" variant="body2" className="font-inherit">
        {notification.recipient_label}
        {notification.is_restricted && (
          <Tooltip title="Visible only to the assigned user and their supervisors / org hierarchy">
            <span className="relative top-[2px] ml-2 inline-block">
              <LockedIcon size={14} className="text-slate-500" />
            </span>
          </Tooltip>
        )}
      </Typography>
      {notification.recipient_sub_label && (
        <Typography display="block" variant="body2" className="font-inherit" color="textSecondary">
          {notification.recipient_sub_label}
        </Typography>
      )}
    </div>
  );
};

export default NotificationAssignee;
